import { render, staticRenderFns } from "./EventStatistics.vue?vue&type=template&id=6877fcc4&scoped=true&"
import script from "./EventStatistics.vue?vue&type=script&lang=js&"
export * from "./EventStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6877fcc4",
  null
  
)

export default component.exports